export default "__VITE_ASSET__BK2xnDpU__"